import { FC } from 'react'
import { Row, Col, Text, Button, Icon, Tag } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { PositionsProps, PositionProps } from '../types'

export const Positions: FC<PositionsProps> = ({ warning, positions, job_name, workfield, workplace }) => {
  const { routerPush } = useRouterPush()
  const { warning_title, warning_description } = warning

  return (
    <>
      {warning_title && warning_description && (
        <Row>
          <Col>
            <S.Box type='gray'>
              <Icon name='warning' size='s9' color='#008FBE' />
              <S.BoxInfos>
                <Text family='heading' size='xlg' weight='bold'>
                  {warning_title}
                </Text>
                <Text color='weak' margin='0'>
                  {warning_description}
                </Text>
              </S.BoxInfos>
            </S.Box>
          </Col>
        </Row>
      )}

      <S.Positions>
        <Row>
          <Col>
            <S.Table>
              <S.TableHeader>
                <S.TableCell>{job_name}</S.TableCell>
                <S.TableCell>{workplace}</S.TableCell>
                <S.TableCell>{workfield}</S.TableCell>
                <S.TableCell></S.TableCell>
              </S.TableHeader>
              <S.TableBody>
                {positions &&
                  positions?.length > 0 &&
                  positions.map(({ job_name, workplace, workfield, job_link, job_label_button }: PositionProps) => (
                    <S.TableRow key={job_name}>
                      <S.TableCell>
                        <Text weight='medium' margin='0'>
                          {job_name}
                        </Text>
                      </S.TableCell>
                      <S.TableCell>
                        <Icon name='place' size='s4' color='#008FBE' />
                        {workplace}
                      </S.TableCell>
                      <S.TableCell>
                        <Tag>{workfield}</Tag>
                      </S.TableCell>
                      <S.TableCell>
                        <Button kind='warning' onClick={() => routerPush(job_link)}>
                          {job_label_button}
                        </Button>
                      </S.TableCell>
                    </S.TableRow>
                  ))}
              </S.TableBody>
            </S.Table>
          </Col>
        </Row>
      </S.Positions>
    </>
  )
}
